import { render, staticRenderFns } from "./ConfirmationSubmit.vue?vue&type=template&id=6a58c0ca&"
import script from "./ConfirmationSubmit.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports